<script setup lang="ts">
useSeoMeta({
    title: "よくあるご質問｜株式会社Bang",
    description: "株式会社Bangのよくあるご質問情報を掲載しています。",

    // OGP設定
    ogTitle: "よくあるご質問｜株式会社Bang",
    ogDescription: "株式会社Bangのよくあるご質問情報を掲載しています。",
    ogUrl: "https://www.bang-inc.jp/faq",
});

const navItems = [
    { text: "トップページ", href: "/" },
    { text: "よくあるご質問" },
];
</script>
<template>
    <main class="faq">
        <!-- パンくずリスト -->
        <Breadcrumbs :items="navItems" />
        <div class="faq-body">
            <HeadingCorp :level="1">よくあるご質問</HeadingCorp>
            <p class="faq-text">
                お問い合わせの多いご質問をまとめましたので、お問い合わせの前にご確認ください。
            </p>
            <QABox />
            <p class="faq-contact">解決しなかった場合は下記よりお問合せください</p>
            <ButtonPrimary size="md" buttonType="contact">お問い合わせはこちら</ButtonPrimary>
        </div>
    </main>
</template>

<style scoped lang="scss">
.faq {
    position: relative;
    width: min(91vw, 64.5rem);
    margin: auto;

    &::before {
        content: '';
        position: absolute;
        width: 20rem; // 320px
        height: 20rem; // 320px
        aspect-ratio: 1/1;
        left: -4rem; // -64px
        top: -3rem; // -48px
        border-radius: 20rem; // 320px
        box-sizing: border-box;
        border: 1.5rem solid #EFF7FF; // 24px
        z-index: -1; // コンテンツの背景に配置
        pointer-events: none; // クリックイベントを通す
    }

    &-body {
        padding: 2rem 0 4.5rem 0;
    }

    &-text {
        width: 100%;
        color: #252522;
        font-size: 1rem;
        font-style: normal;
        font-weight: 400;
        line-height: 150%;
    }
}

.faq-contact {
    color: #252522;
    font-weight: 400;
    font-size: 1rem;
    line-height: 150%;
    padding: 0 0 2.5rem 0;
}

.button-primary {
    margin: auto;
}

// PC用のスタイル
@include mixin.media(pc) {
    .faq {
        &::before {
            width: 32.5rem; // 520px
            height: 32.5rem; // 520px
            left: -10.7rem; // -171.2px
            top: -4rem; // -64px
            border-radius: 32.5rem; // 520px
            border: 2.5rem solid #EFF7FF; // 24px
        }

        &-body {
            padding: 4rem 0 5rem 0;
        }
    }

    .faq-contact {
        padding: 0.5rem 0 1rem 0;
    }

    .button-primary {
        margin: unset;
    }
}
</style>